import React, { useState, useContext } from 'react';
import api from '../utils/api';
import { useNavigate } from 'react-router-dom';
import { OnboardingContext } from '../contexts/OnboardingContext';
import { Phone } from 'lucide-react';
import AuthShell from '../components/common/AuthShell';
import { Button } from '../components/ui';

// Comprehensive list of country calling codes
const COUNTRY_CODES = [
  { code: '+1', country: 'US', flag: '🇺🇸', name: 'United States' },
  { code: '+1', country: 'CA', flag: '🇨🇦', name: 'Canada' },
  { code: '+44', country: 'GB', flag: '🇬🇧', name: 'United Kingdom' },
  { code: '+61', country: 'AU', flag: '🇦🇺', name: 'Australia' },
  { code: '+64', country: 'NZ', flag: '🇳🇿', name: 'New Zealand' },
  { code: '+353', country: 'IE', flag: '🇮🇪', name: 'Ireland' },
  { code: '+49', country: 'DE', flag: '🇩🇪', name: 'Germany' },
  { code: '+33', country: 'FR', flag: '🇫🇷', name: 'France' },
  { code: '+34', country: 'ES', flag: '🇪🇸', name: 'Spain' },
  { code: '+39', country: 'IT', flag: '🇮🇹', name: 'Italy' },
  { code: '+31', country: 'NL', flag: '🇳🇱', name: 'Netherlands' },
  { code: '+32', country: 'BE', flag: '🇧🇪', name: 'Belgium' },
  { code: '+41', country: 'CH', flag: '🇨🇭', name: 'Switzerland' },
  { code: '+43', country: 'AT', flag: '🇦🇹', name: 'Austria' },
  { code: '+46', country: 'SE', flag: '🇸🇪', name: 'Sweden' },
  { code: '+47', country: 'NO', flag: '🇳🇴', name: 'Norway' },
  { code: '+45', country: 'DK', flag: '🇩🇰', name: 'Denmark' },
  { code: '+358', country: 'FI', flag: '🇫🇮', name: 'Finland' },
  { code: '+48', country: 'PL', flag: '🇵🇱', name: 'Poland' },
  { code: '+351', country: 'PT', flag: '🇵🇹', name: 'Portugal' },
  { code: '+30', country: 'GR', flag: '🇬🇷', name: 'Greece' },
  { code: '+420', country: 'CZ', flag: '🇨🇿', name: 'Czech Republic' },
  { code: '+36', country: 'HU', flag: '🇭🇺', name: 'Hungary' },
  { code: '+40', country: 'RO', flag: '🇷🇴', name: 'Romania' },
  { code: '+380', country: 'UA', flag: '🇺🇦', name: 'Ukraine' },
  { code: '+7', country: 'RU', flag: '🇷🇺', name: 'Russia' },
  { code: '+81', country: 'JP', flag: '🇯🇵', name: 'Japan' },
  { code: '+82', country: 'KR', flag: '🇰🇷', name: 'South Korea' },
  { code: '+86', country: 'CN', flag: '🇨🇳', name: 'China' },
  { code: '+852', country: 'HK', flag: '🇭🇰', name: 'Hong Kong' },
  { code: '+886', country: 'TW', flag: '🇹🇼', name: 'Taiwan' },
  { code: '+65', country: 'SG', flag: '🇸🇬', name: 'Singapore' },
  { code: '+60', country: 'MY', flag: '🇲🇾', name: 'Malaysia' },
  { code: '+66', country: 'TH', flag: '🇹🇭', name: 'Thailand' },
  { code: '+84', country: 'VN', flag: '🇻🇳', name: 'Vietnam' },
  { code: '+63', country: 'PH', flag: '🇵🇭', name: 'Philippines' },
  { code: '+62', country: 'ID', flag: '🇮🇩', name: 'Indonesia' },
  { code: '+91', country: 'IN', flag: '🇮🇳', name: 'India' },
  { code: '+92', country: 'PK', flag: '🇵🇰', name: 'Pakistan' },
  { code: '+880', country: 'BD', flag: '🇧🇩', name: 'Bangladesh' },
  { code: '+94', country: 'LK', flag: '🇱🇰', name: 'Sri Lanka' },
  { code: '+977', country: 'NP', flag: '🇳🇵', name: 'Nepal' },
  { code: '+971', country: 'AE', flag: '🇦🇪', name: 'UAE' },
  { code: '+966', country: 'SA', flag: '🇸🇦', name: 'Saudi Arabia' },
  { code: '+972', country: 'IL', flag: '🇮🇱', name: 'Israel' },
  { code: '+90', country: 'TR', flag: '🇹🇷', name: 'Turkey' },
  { code: '+20', country: 'EG', flag: '🇪🇬', name: 'Egypt' },
  { code: '+27', country: 'ZA', flag: '🇿🇦', name: 'South Africa' },
  { code: '+234', country: 'NG', flag: '🇳🇬', name: 'Nigeria' },
  { code: '+254', country: 'KE', flag: '🇰🇪', name: 'Kenya' },
  { code: '+233', country: 'GH', flag: '🇬🇭', name: 'Ghana' },
  { code: '+212', country: 'MA', flag: '🇲🇦', name: 'Morocco' },
  { code: '+52', country: 'MX', flag: '🇲🇽', name: 'Mexico' },
  { code: '+55', country: 'BR', flag: '🇧🇷', name: 'Brazil' },
  { code: '+54', country: 'AR', flag: '🇦🇷', name: 'Argentina' },
  { code: '+56', country: 'CL', flag: '🇨🇱', name: 'Chile' },
  { code: '+57', country: 'CO', flag: '🇨🇴', name: 'Colombia' },
  { code: '+51', country: 'PE', flag: '🇵🇪', name: 'Peru' },
  { code: '+58', country: 'VE', flag: '🇻🇪', name: 'Venezuela' },
  { code: '+593', country: 'EC', flag: '🇪🇨', name: 'Ecuador' },
  { code: '+506', country: 'CR', flag: '🇨🇷', name: 'Costa Rica' },
  { code: '+507', country: 'PA', flag: '🇵🇦', name: 'Panama' },
  { code: '+1-PR', country: 'PR', flag: '🇵🇷', name: 'Puerto Rico' },
  { code: '+1-JM', country: 'JM', flag: '🇯🇲', name: 'Jamaica' },
  { code: '+1-TT', country: 'TT', flag: '🇹🇹', name: 'Trinidad & Tobago' },
  { code: '+1-BB', country: 'BB', flag: '🇧🇧', name: 'Barbados' },
  { code: '+1-BS', country: 'BS', flag: '🇧🇸', name: 'Bahamas' },
];

function AddPhoneForm() {
  const navigate = useNavigate();
  const { setOnboardingStepIfNotComplete } = useContext(OnboardingContext);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [confirmPhoneNumber, setConfirmPhoneNumber] = useState('');
  const [phoneName, setPhoneName] = useState('');
  const [countryCode, setCountryCode] = useState('+1'); // default to US
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const toE164 = (raw, cc) => {
    if (!raw) return '';
    const trimmed = String(raw).trim();
    if (trimmed.startsWith('+')) {
      // Keep only + and digits
      const digits = trimmed.replace(/[^+\d]/g, '');
      return digits;
    }
    const digitsOnly = trimmed.replace(/\D/g, '');
    const ccDigits = String(cc).replace(/\D/g, '');
    return `+${ccDigits}${digitsOnly}`;
  };

  const isValidE164 = (e164) => {
    // E.164 max length 15 digits (excluding leading +), min ~8 for sanity
    if (!e164 || !e164.startsWith('+')) return false;
    const digits = e164.slice(1);
    return /^\d{8,15}$/.test(digits);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('AddPhone handleSubmit:', { phoneNumber, confirmPhoneNumber, phoneName });
    setError('');

    const e164Primary = toE164(phoneNumber, countryCode);
    const e164Confirm = toE164(confirmPhoneNumber, countryCode);

    if (!phoneNumber || !confirmPhoneNumber || !phoneName) {
      setError('All fields are required.');
      return;
    }

    if (e164Primary !== e164Confirm) {
      setError('Phone numbers do not match.');
      return;
    }

    if (!isValidE164(e164Primary)) {
      setError('Please enter a valid phone number. Include area code.');
      return;
    }

    setLoading(true);

    try {
      const res = await api.post('/api/sms/add-phone', {
        phoneNumber: e164Primary,
        confirmPhoneNumber: e164Confirm,
        phoneName
      });
      if (res.data.success) {


        console.log('Phone added successfully:', res.data);

        // Save phoneId (for confirm screen)
        localStorage.setItem('phoneId', res.data.phoneId);

        //await api.get('/user/onboarding', { step: 'opt_in' });
        setOnboardingStepIfNotComplete('opt_in');
        console.log('Setting onboarding step to opt_in');
        navigate('/opt-in');
      } else {
        setError('Failed to add phone.');
      }
    } catch (err) {
      console.error('Error adding phone:', err);
      const msg = err.response?.data?.error || 'Failed to add phone.';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell>
            <div className="mb-6 sm:mb-8">
              <div className="flex items-center justify-center mb-4">
                <div className="bg-blue-100 p-3 rounded-full">
                  <Phone className="w-6 h-6 text-blue-600" />
                </div>
              </div>
              <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2 text-center">
                Add Phone Number
              </h1>
              <p className="text-gray-600 text-center">
                We'll send SMS notifications to this number
              </p>
            </div>

            {error && (
              <div className="mb-6 rounded-md border border-red-200 bg-red-50 p-4 text-sm text-red-800">
                <div className="font-semibold">⚠️ Error</div>
                <p className="mt-1">{error}</p>
              </div>
            )}

            <form onSubmit={handleSubmit} className="space-y-4 sm:space-y-5">
              {/* Phone Number */}
              <div>
                <label className="block text-base sm:text-sm font-medium text-gray-700 mb-1">
                  Phone Number
                </label>
                <div className="flex gap-2">
                  <select
                    value={countryCode}
                    onChange={(e) => setCountryCode(e.target.value)}
                    className="input-field w-28 sm:w-40 flex-shrink-0"
                    aria-label="Country calling code"
                  >
                    {COUNTRY_CODES.map((c) => (
                      <option key={`${c.code}-${c.country}`} value={c.code === '+1' && c.country !== 'US' ? `${c.code}-${c.country}` : c.code}>
                        {c.flag} {c.code} {c.name}
                      </option>
                    ))}
                  </select>
                  <input
                    type="tel"
                    placeholder="555 123 4567"
                    value={phoneNumber}
                    onChange={(e) => setPhoneNumber(e.target.value)}
                    className="input-field flex-1 min-w-0"
                    required
                    autoComplete="tel"
                  />
                </div>
              </div>

              {/* Confirm Phone Number */}
              <div>
                <label className="block text-base sm:text-sm font-medium text-gray-700 mb-1">
                  Confirm Phone Number
                </label>
                <div className="flex gap-2">
                  <select
                    value={countryCode}
                    onChange={(e) => setCountryCode(e.target.value)}
                    className="input-field w-28 sm:w-40 flex-shrink-0"
                    aria-label="Country calling code (confirm)"
                  >
                    {COUNTRY_CODES.map((c) => (
                      <option key={`confirm-${c.code}-${c.country}`} value={c.code === '+1' && c.country !== 'US' ? `${c.code}-${c.country}` : c.code}>
                        {c.flag} {c.code} {c.name}
                      </option>
                    ))}
                  </select>
                  <input
                    type="tel"
                    placeholder="Re-enter phone number"
                    value={confirmPhoneNumber}
                    onChange={(e) => setConfirmPhoneNumber(e.target.value)}
                    className="input-field flex-1 min-w-0"
                    required
                    autoComplete="tel"
                  />
                </div>
              </div>

              {/* Info box */}
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 sm:p-4">
                <p className="text-sm text-blue-900">
                  Numbers will be normalized to international format (E.164), e.g., +15551234567.
                  You'll review SMS opt-in on the next screen.
                </p>
              </div>

              {/* Phone Name */}
              <div>
                <label className="block text-base sm:text-sm font-medium text-gray-700 mb-1">
                  Phone Name
                </label>
                <input
                  type="text"
                  placeholder="e.g., Personal Cell"
                  value={phoneName}
                  onChange={(e) => setPhoneName(e.target.value)}
                  className="input-field w-full"
                  required
                />
                <p className="mt-1 text-sm text-gray-500">
                  Give this number a friendly name to identify it
                </p>
              </div>

              {/* Submit button */}
              <Button type="submit" variant="primary" fullWidth disabled={loading} loading={loading}>
                {loading ? 'Sending Code' : 'Continue'}
              </Button>
            </form>
    </AuthShell>
  );
}

// Wrap the form in the OnboardGuard to enforce the onboarding step
export default function AddPhone() {
  return <AddPhoneForm />;
}